const TmpL010 = (page, section) => {
  const eMentors = [];
  const modifiedPage = {
    ...page,
  };

  page.content.core.forEach((question, index) => {
    // combine the question and answer into a single object
    modifiedPage.content.core[index].incorrect_feedback = [question.incorrect_feedback_1, question.incorrect_feedback_2, question.incorrect_feedback_3];
    // remove the incoreect responses from the modified page data
    delete modifiedPage.content.core[index].incorrect_feedback_1;
    delete modifiedPage.content.core[index].incorrect_feedback_2;
    delete modifiedPage.content.core[index].incorrect_feedback_3;
  });

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id,
      };
      eMentors.push(eMentor);
    });
  } 

  // Extract metadata separately
  const metadata = {
    media: [],
    images: [],
    materials: [],
    eMentor: eMentors,
    focusPoints: [],
  };

  return { modifiedPage, metadata };
};

export default TmpL010;